import { atom } from 'recoil'

import { CreateClaimApprovalModalProps } from './types'

const createClaimApprovalModal: CreateClaimApprovalModalProps = {
  open: false,
  onSuccess: undefined,
}

const createClaimApprovalModalAtom = atom({
  key: 'createClaimApprovalModalAtom',
  default: createClaimApprovalModal,
})

export default createClaimApprovalModalAtom
